import { createSelector, createSelectorMemoized } from '@mui/x-internals/store';
export const chatSelectors = {
  messageIds: createSelector(state => state.messageIds),
  messagesById: createSelector(state => state.messagesById),
  conversationIds: createSelector(state => state.conversationIds),
  conversationsById: createSelector(state => state.conversationsById),
  activeConversationId: createSelector(state => state.activeConversationId),
  isStreaming: createSelector(state => state.isStreaming),
  hasMoreHistory: createSelector(state => state.hasMoreHistory),
  error: createSelector(state => state.error),
  messages: createSelectorMemoized(state => state.messageIds, state => state.messagesById, (messageIds, messagesById) => messageIds.map(id => messagesById[id])),
  message: createSelector(state => state.messagesById, (messagesById, id) => messagesById[id]),
  conversations: createSelectorMemoized(state => state.conversationIds, state => state.conversationsById, (conversationIds, conversationsById) => conversationIds.map(id => conversationsById[id])),
  conversation: createSelector(state => state.conversationsById, (conversationsById, id) => conversationsById[id]),
  activeConversation: createSelector(state => state.activeConversationId, state => state.conversationsById, (activeConversationId, conversationsById) => activeConversationId == null ? undefined : conversationsById[activeConversationId]),
  messageCount: createSelector(state => state.messageIds, messageIds => messageIds.length),
  conversationCount: createSelector(state => state.conversationIds, conversationIds => conversationIds.length),
  composerValue: createSelector(state => state.composerValue),
  composerAttachments: createSelector(state => state.composerAttachments),
  /**
   * Returns the IDs of users currently typing in the given conversation.
   * If no conversationId argument is provided, falls back to the active conversation.
   */
  typingUserIds: createSelectorMemoized(state => state.typingByConversation, state => state.activeConversationId, (typingByConversation, activeConversationId, conversationId) => {
    const id = conversationId ?? activeConversationId;
    if (!id) {
      return [];
    }
    const byUser = typingByConversation[id];
    if (!byUser) {
      return [];
    }
    return Object.keys(byUser).filter(userId => byUser[userId]);
  }),
  /**
   * Returns the IDs of users currently typing in the active conversation.
   * Use this instead of `typingUserIds(state, undefined)` to avoid creating an inline wrapper
   * function that would defeat memoization.
   */
  typingUserIdsForActiveConversation: createSelectorMemoized(state => state.typingByConversation, state => state.activeConversationId, (typingByConversation, activeConversationId) => {
    if (!activeConversationId) {
      return [];
    }
    const byUser = typingByConversation[activeConversationId];
    if (!byUser) {
      return [];
    }
    return Object.keys(byUser).filter(userId => byUser[userId]);
  })
};
export const selectMessageIds = chatSelectors.messageIds;
export const selectMessagesById = chatSelectors.messagesById;
export const selectConversationIds = chatSelectors.conversationIds;
export const selectConversationsById = chatSelectors.conversationsById;
export const selectActiveConversationId = chatSelectors.activeConversationId;
export const selectIsStreaming = chatSelectors.isStreaming;
export const selectHasMoreHistory = chatSelectors.hasMoreHistory;
export const selectError = chatSelectors.error;
export const selectMessages = chatSelectors.messages;
export const selectMessage = chatSelectors.message;
export const selectConversations = chatSelectors.conversations;
export const selectConversation = chatSelectors.conversation;
export const selectActiveConversation = chatSelectors.activeConversation;
export const selectMessageCount = chatSelectors.messageCount;
export const selectConversationCount = chatSelectors.conversationCount;
export const selectComposerValue = chatSelectors.composerValue;
export const selectComposerAttachments = chatSelectors.composerAttachments;
export const selectTypingUserIds = chatSelectors.typingUserIds;
export const selectTypingUserIdsForActiveConversation = chatSelectors.typingUserIdsForActiveConversation;